import React from "react";
import { useTranslation } from "react-i18next";
import "./BookingTabs.css";

const BookingTabs = ({ 
  activeTab, 
  onTabChange, 
  bookingsCount = 0, 
  subRequestsCount = 0,
  statusFilter,
  onStatusFilterChange
}) => {
  const { t } = useTranslation("booking");

  return (
    <div className="booking-tabs-container">
      <div className="booking-tabs-row">
        <div className="booking-tabs">
          <button
            className={`booking-tab ${activeTab === "bookings" ? "active" : ""}`}
            onClick={() => onTabChange("bookings")}
          >
            {t("tabs.bookings")} ({bookingsCount})
          </button>
          <button
            className={`booking-tab ${activeTab === "subRequests" ? "active" : ""}`}
            onClick={() => onTabChange("subRequests")}
          >
            {t("tabs.subRequests")} ({subRequestsCount})
          </button>
        </div>
        
        <div className="status-select">
          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
          >
            <option value="allStatus">
              {t("statusFilter.allStatus")}
            </option>
            <option value="pending">{t("statusFilter.pending")}</option>
            {activeTab === "bookings" ? (
              <>
                <option value="accepted">{t("statusFilter.accepted")}</option>
                <option value="paid">{t("statusFilter.paid")}</option>
              </>
            ) : (
              <option value="approved">{t("statusFilter.approved")}</option>
            )}
            <option value="rejected">{t("statusFilter.rejected")}</option>
            <option value="cancelled">{t("statusFilter.cancelled")}</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default BookingTabs;